import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b9b8c3d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "media-coverage"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "media-coverage-swiper-item-title"
};
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
// import required modules
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
export default /*#__PURE__*/_defineComponent({
  __name: 'media-coverage',
  setup(__props) {
    const modules = [Pagination];
    const coverageList = [{
      image: "https://img2.qiuwenxinli.com/official-website/index/media-coverage-2.jpg",
      title: "幸福心理学创始人徐秋秋《教练式父母》新书分享会杭州站成功举办",
      url: "https://hea.china.com/article/20230525/052023_1288831.html"
    }, {
      image: "https://img2.qiuwenxinli.com/official-website/index/media-coverage-1.png",
      title: "用阅读建立国民心理健康的精神防线——李文超、徐秋秋做客文化泉城",
      url: "https://www.sohu.com/a/538550252_121124730"
    }, {
      image: "https://img2.qiuwenxinli.com/material_library_1695180744538.png",
      title: "心理学+VR科技全生态，秋文心理构建“国民心理幸福”一站式解决方案",
      url: "https://tech.china.com/article/20220322/032022_1034621.html"
    }, {
      image: "https://nimg.ws.126.net/?url=http%3A%2F%2Fdingyue.ws.126.net%2F2022%2F0726%2F422039a4j00rfmc7s00t5d000v900kup.jpg&thumbnail=660x2147483647&quality=80&type=jpg",
      title: "幸福的真相—幸福心理学企业家高峰论坛盛大开幕",
      url: "https://www.163.com/dy/article/HD7DD6PN051495SS.html"
    }, {
      image: "http://pic.wy6000.com/upload/image/rw/doc/20230601/editor_3419_45576343fde3a5aaf0ee1d609655ad1b.png",
      title: "幸福心理学创始人李文超、徐秋秋荣登当当网第九届影响力作家榜",
      url: "https://hea.china.com/article/20230601/062023_1302455.html"
    }];
    function clickItem(swiper, event) {
      console.log(swiper.clickedIndex);
      console.log(event);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Swiper), {
        style: {
          '--swiper-theme-color': '#FFC56E'
        },
        modules: modules,
        slidesPerView: 2,
        loop: true,
        pagination: {
          clickable: true,
          dynamicBullets: true
        },
        onClick: clickItem,
        class: "media-coverage-swiper"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(coverageList, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              class: "media-coverage-swiper-item",
              href: item.url
            }, [_createElementVNode("img", {
              class: "media-coverage-swiper-item-img",
              src: item.image
            }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1)], 8, _hoisted_2)]),
            _: 2
          }, 1024);
        }), 64))]),
        _: 1
      })]);
    };
  }
});